/* KK16 V4: cart-drawer happy-hour countdown, letter "scroll down for more",
   and the Mr. Whiskey video fallback. Loaded once from snippets/cart-drawer.liquid.

   The drawer's innerHTML is replaced on every cart change (cart-drawer.js
   renderContents / CartItems), so nothing here binds to specific nodes: the 1s
   tick re-queries the DOM and click handling is delegated on document.

   Countdown: 1 hour from the first time this browser sees it (localStorage).
   It keeps counting across page loads; once it hits zero a fresh hour starts
   on the next visit, so nobody sees a dead 00:00:00 bar. */
(function () {
  var KEY = 'kk16v4_hh_end';
  var HOUR = 60 * 60 * 1000;

  function getEnd() {
    var end = 0;
    try { end = parseInt(localStorage.getItem(KEY), 10) || 0; } catch (e) {}
    var now = Date.now();
    if (!end || end < now - 5000) {
      end = now + HOUR;
      try { localStorage.setItem(KEY, String(end)); } catch (e) {}
    }
    return end;
  }

  function pad(n) { return (n < 10 ? '0' : '') + n; }

  function tick() {
    var timers = document.querySelectorAll('[data-kk16v4-timer]');
    if (timers.length) {
      var left = Math.max(0, getEnd() - Date.now());
      var s = Math.floor(left / 1000);
      var text = pad(Math.floor(s / 3600)) + ':' + pad(Math.floor((s % 3600) / 60)) + ':' + pad(s % 60);
      timers.forEach(function (el) { if (el.textContent !== text) el.textContent = text; });
    }
    initVideos();
    initScrollBoxes();
  }

  /* ---- Mr. Whiskey video ----
     Two encodes of the same clip:
       webm  = VP9 + alpha  → Chrome / Firefox / Android. Painted through a
               <canvas>: Chrome decodes alpha video fine but sometimes never
               paints the <video> itself (unpainted box, pause/resume);
               drawImage() always works.
       hevc  = HEVC + alpha (hvc1, mp4) → Safari / iOS, which cannot decode
               VP9 alpha. Played directly in the <video>.
     Anything else (or a failed load) → the still jpg (mix-blend multiply). */
  function isWebKitOnly() {
    var ua = navigator.userAgent;
    /* every iOS browser is WebKit (CriOS/FxiOS included); iPadOS Safari
       reports a desktop "Macintosh" UA, so use touch points for it */
    var ios = /iPad|iPhone|iPod/.test(ua) ||
      (/Macintosh/.test(ua) && navigator.maxTouchPoints > 1 && !/android|chrome|chromium|edg/i.test(ua));
    var safari = /safari/i.test(ua) && !/chrome|crios|chromium|android|edg|fxios|opr/i.test(ua);
    return ios || safari;
  }
  function pickSource(video) {
    var probe = document.createElement('video');
    var can = function (t) { return !!probe.canPlayType && probe.canPlayType(t) !== ''; };
    var webm = video.querySelector('[data-kk16v4-webm]');
    var hevc = video.querySelector('[data-kk16v4-hevc]');
    if (!isWebKitOnly() && webm && can('video/webm; codecs="vp9"')) {
      if (hevc) hevc.remove();
      return 'webm';
    }
    if (hevc && can('video/mp4; codecs="hvc1.1.6.L93.B0"')) {
      if (webm) webm.remove();
      return 'hevc';
    }
    return null;
  }
  function showFallback(video, fallback) {
    video.hidden = true;
    video.removeAttribute('autoplay');
    try { video.pause(); } catch (e) {}
    if (fallback) fallback.hidden = false;
    var c = video.parentNode && video.parentNode.querySelector('.kk16v4-canvas');
    if (c) c.remove();
  }
  function initVideos() {
    var vids = document.querySelectorAll('video[data-kk16v4-video]:not([data-kk16v4-init])');
    vids.forEach(function (video) {
      video.setAttribute('data-kk16v4-init', '1');
      var wrap = video.parentNode;
      var fallback = wrap && wrap.querySelector('.kk16v4-video-fallback');
      var mode = pickSource(video);
      if (!mode) { showFallback(video, fallback); return; }
      video.addEventListener('error', function () { showFallback(video, fallback); });
      /* <source> errors bubble as 'error' on the last source only */
      var last = video.querySelector('source:last-of-type');
      if (last) last.addEventListener('error', function () { showFallback(video, fallback); });

      if (mode === 'webm') {
        var canvas = document.createElement('canvas');
        canvas.className = 'kk16v4-canvas';
        canvas.setAttribute('aria-hidden', 'true');
        canvas.width = parseInt(video.getAttribute('width'), 10) || 295;
        canvas.height = parseInt(video.getAttribute('height'), 10) || 310;
        wrap.insertBefore(canvas, video);
        video.classList.add('kk16v4-video--src');
        var ctx = canvas.getContext('2d');
        var lastT = -1;
        var draw = function () {
          if (!video.videoWidth || video.readyState < 2) return;
          var cssW = canvas.clientWidth || 300;
          var dpr = Math.min(window.devicePixelRatio || 1, 2);
          var pw = Math.round(cssW * dpr);
          var ph = Math.round(pw * video.videoHeight / video.videoWidth);
          if (canvas.width !== pw || canvas.height !== ph) { canvas.width = pw; canvas.height = ph; }
          ctx.clearRect(0, 0, pw, ph);
          ctx.drawImage(video, 0, 0, pw, ph);
          lastT = video.currentTime;
        };
        var loop = function () {
          if (!document.contains(video)) return; /* drawer re-rendered: stop */
          if (video.currentTime !== lastT) draw();
          requestAnimationFrame(loop);
        };
        video.addEventListener('loadeddata', draw);
        requestAnimationFrame(loop);
      }
      try { video.load(); } catch (e) {}
      tryPlay(video, fallback);
    });
    /* The theme's modal-dialog calls window.pauseAllMedia() on open/close,
       which pauses every <video> on the page — nudge ours back to playing. */
    document.querySelectorAll('video[data-kk16v4-init]:not([hidden])').forEach(function (video) {
      if (video.paused && !video.ended) tryPlay(video, null);
    });
  }
  function tryPlay(video, fallback) {
    var p = video.play && video.play();
    if (p && typeof p.catch === 'function') {
      p.catch(function (err) {
        /* AbortError (interrupted by pause()/load()) is harmless; only a real
           autoplay block should swap in the still image. */
        if (fallback && err && err.name === 'NotAllowedError') showFallback(video, fallback);
      });
    }
  }

  /* ---- letter scroll box ---- */
  function updateBox(box) {
    var btn = box.parentNode.querySelector('[data-kk16v4-more]');
    var atEnd = box.scrollTop + box.clientHeight >= box.scrollHeight - 4;
    box.classList.toggle('is-end', atEnd);
    if (btn) btn.classList.toggle('is-up', atEnd);
  }
  function initScrollBoxes() {
    var boxes = document.querySelectorAll('[data-kk16v4-scrollbox]:not([data-kk16v4-init])');
    boxes.forEach(function (box) {
      box.setAttribute('data-kk16v4-init', '1');
      box.addEventListener('scroll', function () { updateBox(box); }, { passive: true });
      updateBox(box);
    });
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-kk16v4-more]');
    if (!btn) return;
    var box = btn.closest('.kk16v4-letter') && btn.closest('.kk16v4-letter').querySelector('[data-kk16v4-scrollbox]');
    if (!box) return;
    if (btn.classList.contains('is-up')) {
      box.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      box.scrollBy({ top: Math.round(box.clientHeight * 0.85), behavior: 'smooth' });
    }
    setTimeout(function () { updateBox(box); }, 400);
  });

  function init() {
    tick();
    setInterval(tick, 1000);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
